module.exports = __webpack_public_path__ + "static/media/timeline-step-5.a4cea26e.png";